import React from 'react';
import PropTypes from 'prop-types';

function FormToggle({
  id, label, name, onChange, value,
}) {
  return (
    <label
      aria-checked={value}
      className={`c-form-toggle ${value ? 'is-checked' : ''}`}
      htmlFor={id}
      id="label-toggle"
      onClick={() => onChange(!value)}
      onKeyDown={() => onChange(!value)}
      role="switch"
      tabIndex={0}
    >
      <input id={id} name={name} type="hidden" value={value} />
      <span className="c-form-toggle__slider" />
      <span className="c-form-toggle__label">{label}</span>
    </label>
  );
}

FormToggle.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.bool.isRequired,
};

export default FormToggle;
